import { render, staticRenderFns } from "./DargainDetails.vue?vue&type=template&id=003bfd4c"
import script from "./DargainDetails.vue?vue&type=script&lang=js"
export * from "./DargainDetails.vue?vue&type=script&lang=js"
import style0 from "./DargainDetails.vue?vue&type=style&index=0&id=003bfd4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports